<ion-item button class="compact" lines="none" detail="false" (click)="openDropDown($event)">
    <ion-icon *ngIf="!autoOpen" slot="start" name="calendar"></ion-icon>
    <ion-label *ngIf="!inline && fullDate" position="stacked" class="fullWidth compactlabel">
        {{translationPrefix + '.name' | translate}}
    </ion-label>
    <ion-item button class="compact inner" lines="none" detail="false">
        <ion-label *ngIf="!fullDate" position="inline" class="search-all">
            {{translationPrefix + '.all' | translate}}
        </ion-label>
        <ion-label *ngIf="fullDate" position="inline" class="labelSmallMargin" text-wrap>
            {{fullDate}}
        </ion-label>
        <ion-icon *ngIf="!inline && fullDate" name="close" (click)="clearDate($event)">
        </ion-icon>
    </ion-item>
</ion-item>
